export interface IFeeRange {
  greater_than: string;
  less_than_equal_to: string;
  amount: string;
  percentage: string;
}
